import { IRouterProps } from '@interfaces/App.interface';
import { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateBasicColumn, generateGlobalColumns, IDataGridConfig, TInheritedProps } from '@ts/storybook';
import { IConfigComponent } from '@ts/ui-models';
import { useMemo } from 'react';

interface IUniqueIdSeriesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('uniqueIdSerie');

const UniqueIdSeries = (props: IUniqueIdSeriesProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'prefix' }, { field: 'prefix' }),
      generateBasicColumn({ field: 'lastIDUsed', headerName: 'Last ID used' }, { field: 'lastIDUsed' }),
      generateBasicColumn({ field: 'lastIDUsedEntity', headerName: 'Last ID used entity' }, { field: 'lastIDUsedEntity' }),
      generateBasicColumn({ field: 'lastIDUsedTS', headerName: 'Last ID timestamp used' }, { field: 'lastIDUsedTS' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      inheritedProps={inheritedProps}
    />
  );
};

export default UniqueIdSeries;
